const headerData = [
    {text: "Home", link: "/"},
    {text: "Application", link: "/application", icon: "history_edu"}
]

export {headerData}